import { render, staticRenderFns } from "./StepSelectUBA.vue?vue&type=template&id=e38a0ee2&scoped=true&"
import script from "./StepSelectUBA.vue?vue&type=script&lang=js&"
export * from "./StepSelectUBA.vue?vue&type=script&lang=js&"
import style0 from "./StepSelectUBA.vue?vue&type=style&index=0&id=e38a0ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38a0ee2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VAlert,VBtn,VDivider})
